import React from "react";
import logger from "../libs/logger";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logger.report_error('ErrorBoundary.componentDidCatch', 'error', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h3 className="text-red-700 font-bold">Something went wrong.</h3>;
    }

    return this.props.children;
  }
}